var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHighPriorityIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 11,
    viewBox: "0 0 3 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.52711 0.771484L2.37378 7.49012H0.877651L0.728967 0.771484H2.52711ZM1.62572 10.3895C1.34384 10.3895 1.10223 10.2903 0.900883 10.0921C0.702638 9.89384 0.603516 9.65223 0.603516 9.36726C0.603516 9.08847 0.702638 8.84996 0.900883 8.65172C1.10223 8.45347 1.34384 8.35435 1.62572 8.35435C1.9014 8.35435 2.13991 8.45347 2.34126 8.65172C2.5457 8.84996 2.64792 9.08847 2.64792 9.36726C2.64792 9.55621 2.5999 9.72812 2.50388 9.883C2.41095 10.0379 2.28705 10.1618 2.13217 10.2547C1.98039 10.3445 1.81157 10.3895 1.62572 10.3895Z",
    fill: "#FB0C0C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighPriorityIcon);
export default __webpack_public_path__ + "static/media/highPriorityIcon.cd90ffe987542a55528cd62a96effcb6.svg";
export { ForwardRef as ReactComponent };